import React from 'react';
import { useTheme } from 'styled-components';

const ArrowLeft = ({ color }) => {
    const theme = useTheme();
    return (React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "32", height: "32", viewBox: "0 0 32 32", fill: "none" },
        React.createElement("g", { clipPath: "url(#clip0_7500_536)" },
            React.createElement("path", { d: "M22 1.5L11.5 16L22 31", stroke: color !== null && color !== void 0 ? color : theme.colors.arrowColor, strokeWidth: "3.5" })),
        React.createElement("defs", null,
            React.createElement("clipPath", { id: "clip0_7500_536" },
                React.createElement("rect", { width: "32", height: "32", fill: color !== null && color !== void 0 ? color : theme.colors.arrowColor })))));
};

export { ArrowLeft as default };
//# sourceMappingURL=ArrowLeft.mjs.map
